import './ParcoursMasteryCard.css'

function ParcoursMasteryCard({ summary, isGuest = false, onOpenParcours, onConnect }) {
  if (isGuest) {
    return (
      <div className="parcours-mastery-card">
        <p className="parcours-mastery-eyebrow">Parcours</p>
        <p className="parcours-mastery-empty">
          Connecte-toi pour suivre ton avancement dans le parcours guidé.
        </p>
        {onConnect ? (
          <button type="button" className="parcours-mastery-cta" onClick={onConnect}>
            Se connecter
          </button>
        ) : null}
      </div>
    )
  }

  if (!summary?.activeNodeId) {
    return (
      <div className="parcours-mastery-card">
        <p className="parcours-mastery-eyebrow">Parcours</p>
        <p className="parcours-mastery-empty">
          Le parcours te guide étape par étape. Commence la première pour débloquer la suite.
        </p>
        {onOpenParcours ? (
          <button type="button" className="parcours-mastery-cta" onClick={onOpenParcours}>
            Ouvrir le parcours
          </button>
        ) : null}
      </div>
    )
  }

  const showAverage = summary.attempts >= 2 && summary.averageScore != null

  return (
    <div className="parcours-mastery-card">
      <p className="parcours-mastery-eyebrow">Étape en cours</p>
      <p className="parcours-mastery-stage">{summary.stageLabel}</p>
      <p className="parcours-mastery-node-label">{summary.activeNodeLabel}</p>
      {summary.activeNodeSubtitle ? (
        <p className="parcours-mastery-node-subtitle">{summary.activeNodeSubtitle}</p>
      ) : null}

      {summary.modeExplanation ? (
        <p className="parcours-mastery-mode-expl">{summary.modeExplanation}</p>
      ) : null}

      <div
        className="parcours-mastery-bar-wrap"
        role="progressbar"
        aria-valuenow={summary.percentUnlocked}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={`${summary.unlockedCount} étapes débloquées sur ${summary.totalNodes}`}
      >
        <div className="parcours-mastery-bar" style={{ width: `${summary.percentUnlocked}%` }} />
      </div>
      <p className="parcours-mastery-meta">
        {summary.unlockedCount} / {summary.totalNodes} étapes débloquées
        {showAverage ? ` · Moyenne sur cette étape : ${summary.averageScore}%` : ''}
        {summary.attempts > 0
          ? ` · ${summary.attempts} tentative${summary.attempts > 1 ? 's' : ''}`
          : ' · Pas encore commencé'}
      </p>

      {summary.nextUnlockHint ? (
        <p className="parcours-mastery-hint">{summary.nextUnlockHint}</p>
      ) : null}

      {onOpenParcours ? (
        <button type="button" className="parcours-mastery-cta" onClick={onOpenParcours}>
          Continuer cette étape
        </button>
      ) : null}
    </div>
  )
}

export default ParcoursMasteryCard
